import script from "./ProfileOther.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileOther.vue?vue&type=script&setup=true&lang=js"

import "./ProfileOther.vue?vue&type=style&index=0&id=1ae93389&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae93389"]])

export default __exports__